var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { useEffect, useMemo, useRef } from "react";
import { useIntersectionObserver, getTargetElement } from "../lazy-load/intersection-observer";
import "./header.css";
var classPrefix = "bbt-react-header";

var Header = function (_a) {
  var _b, _c;

  var _d = _a.className,
      className = _d === void 0 ? "" : _d,
      _e = _a.styles,
      styles = _e === void 0 ? {} : _e,
      _f = _a.showBackground,
      showBackground = _f === void 0 ? "#FFFFFF" : _f,
      _g = _a.block,
      block = _g === void 0 ? true : _g,
      _h = _a.scrollOpacity,
      scrollOpacity = _h === void 0 ? true : _h,
      children = _a.children,
      _j = _a.containerStyles,
      containerStyles = _j === void 0 ? {} : _j,
      _k = _a.root,
      root = _k === void 0 ? null : _k,
      onIntersection = _a.onIntersection;
  var headerRef = useRef(null);
  var headerFixRef = useRef(null);

  var _l = useIntersectionObserver(),
      observe = _l[0],
      listen = _l[1];

  var opacity = useMemo(function () {
    var rate = scrollOpacity ? (observe === null || observe === void 0 ? void 0 : observe.intersectionRatio) || 0 : 0;
    var op = 1 - Number(rate);
    op = Math.floor(op * 10) / 10;
    if (op < 0.1) op = 0;
    if (op > 0.9) op = 1;
    var style = {
      "--bbt-header-opacity": "".concat(op),
      "--bbt-header-background": showBackground
    };
    onIntersection && (onIntersection === null || onIntersection === void 0 ? void 0 : onIntersection(op));
    return style;
  }, [observe]);
  useEffect(function () {
    listen({
      element: getTargetElement(headerRef.current),
      threshold: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(function (el) {
        return el / 10;
      }),
      root: root
    });
  }, []);
  return React.createElement("div", {
    className: "".concat(classPrefix, " ").concat(className),
    ref: headerRef,
    style: __assign({}, containerStyles)
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-fix"),
    ref: headerFixRef,
    style: __assign(__assign({}, styles), opacity)
  }, children), block ? React.createElement("div", {
    className: "".concat(classPrefix, "-block"),
    style: {
      height: ((_c = (_b = headerFixRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()) === null || _c === void 0 ? void 0 : _c.height) || 0
    }
  }) : null);
};

export { Header };